// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.bDqMxf {
  display: flex;
  flex-grow: 1;
  padding: 0 var(--spacing-3) var(--spacing-3);
  overflow-y: auto;
}

.IDsnJj {
  display: flex;
  flex-direction: column;
  gap: var(--spacing-3);
  padding: 0;
  min-height: 0;
  width: 100%;
}

.fbxnfz {
  display: flex;
  align-items: center;
  border-bottom: 1px solid var(--stroke-neutral-subtle);
  box-sizing: border-box;
  flex-shrink: 0;
  gap: var(--spacing-3);
  height: 60px;
  margin: 0 calc(var(--spacing-3) * -1);
  overflow-x: auto;
  padding: var(--spacing-3) var(--spacing-3) 0;
  width: calc(100% + var(--spacing-3) + var(--spacing-3));
}

.RMINW0 {
  appearance: none;
  background: transparent;
  border: 0;
  color: var(--text-neutral-dark);
  flex: 1;
  font-family: var(--font-family-base);
  font-size: var(--font-size-sm);
  font-weight: var(--font-weight-regular);
  line-height: var(--line-height-100);
  min-width: max-content;
  padding: var(--spacing-1);
  text-align: center;
  white-space: nowrap;
}

.Df9UK5 {
  flex: 0 0 auto;
}

.RMINW0:focus-visible {
  outline: 2px solid var(--stroke-primary-medium);
  outline-offset: -2px;
}

.KdlWP7 {
  color: var(--text-neutral-dark);
  font-family: var(--font-family-base);
  font-size: var(--font-size-lg);
  font-weight: var(--font-weight-medium);
  line-height: var(--line-height-100);
  margin: 0;
}

.O32hhc {
  display: flex;
  flex-direction: column;
  gap: var(--spacing-2);
  scroll-margin-top: var(--spacing-2);
  width: 100%;
}

.cCeyT9 {
  color: var(--text-neutral-dark);
  font-family: var(--font-family-base);
  font-size: var(--font-size-lg);
  font-weight: var(--font-weight-semibold);
  line-height: var(--line-height-100);
  margin: 0;
}

.cEeBnF {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  min-height: 240px;
  gap: var(--spacing-2);
  padding: var(--spacing-3);
}

.wNc7mK {
  font-family: var(--font-family-base);
  font-weight: var(--font-weight-semibold);
  font-size: var(--font-size-md);
  line-height: var(--line-height-180);
  color: var(--text-neutral-dark);
  margin: 0;
  text-align: center;
}

.BcNUH6 {
  font-family: var(--font-family-base);
  font-weight: var(--font-weight-regular);
  font-size: var(--font-size-md);
  line-height: var(--line-height-180);
  color: var(--text-neutral-stronger);
  margin: 0;
  text-align: center;
}

.pSKvBs,
.gwgJEz {
  background: var(--surface-neutral-white);
  border: 1px solid var(--stroke-neutral-subtle);
  border-radius: var(--radius-s);
  padding: var(--spacing-3);
  display: flex;
  flex-direction: column;
  gap: var(--spacing-2);
  width: 100%;
  box-sizing: border-box;
}

.s5qDEy {
  display: flex;
  flex-direction: column;
  gap: var(--spacing-0-5);
}

.F7nt7x {
  display: flex;
  flex-direction: column;
  gap: var(--spacing-0-5);
}

.lfUn_z {
  display: flex;
  flex-direction: column;
  gap: var(--spacing-0-5);
}

.bigyWc {
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  gap: 0;
}

.LosSCr {
  display: flex;
  align-items: flex-end;
  justify-content: space-between;
  gap: var(--spacing-1);
}

.DCg1pb {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: var(--spacing-0-5);
  min-height: 25px;
}

.Oyl51I {
  font-family: var(--font-family-base);
  font-weight: var(--font-weight-regular);
  font-size: var(--font-size-md);
  line-height: var(--line-height-180);
  color: var(--text-neutral-dark);
}

.HYNh1K {
  font-family: var(--font-family-base);
  font-weight: var(--font-weight-semibold);
  font-size: var(--font-size-md);
  line-height: var(--line-height-180);
  color: var(--text-neutral-dark);
}

.F_rUAi {
  font-size: var(--font-size-lg);
  line-height: var(--line-height-100);
}

.bdy9qW {
  border: none;
  border-top: 1px solid var(--stroke-neutral-subtle);
  margin: 0;
  width: 100%;
}

.Towdbi {
  display: flex;
  align-items: center;
  gap: var(--spacing-0-5);
  flex-shrink: 0;
}

.HERnfr {
  width: var(--spacing-3);
  height: var(--spacing-3);
  padding: 0;
  display: flex;
  align-items: center;
  justify-content: center;
  background: none;
  border: none;
  cursor: pointer;
  flex-shrink: 0;
}

.SVkSGa {
  gap: var(--spacing-0-5);
  margin: 0;
  padding: 0;
  white-space: nowrap;
  flex-shrink: 0;
}

.nmU_B4 {
  background: var(--surface-neutral-white);
  border: 1px solid var(--stroke-neutral-subtle);
  border-radius: var(--radius-s);
  box-sizing: border-box;
  display: flex;
  flex-direction: column;
  gap: var(--spacing-2);
  padding: var(--spacing-3);
  width: 100%;
}

.CRM1St {
  align-items: flex-start;
  display: flex;
  gap: var(--spacing-1);
  width: 100%;
}

.nkh1UN {
  align-items: center;
  border-radius: 50%;
  display: flex;
  flex-shrink: 0;
  height: 22px;
  justify-content: center;
  width: 22px;
}

.smNzXt {
  background: var(--status-success-soft, #eef8ec);
}

.SYiDJp {
  background: var(--status-info-soft, #e6f2fe);
}

.h3SIfX {
  background: var(--surface-neutral-subtle, #f2f2f2);
}

.YIsqnM {
  height: 12px;
  width: 12px;
}

._TeGew {
  color: var(--text-neutral-dark);
  display: flex;
  flex: 1;
  flex-direction: column;
  font-family: var(--font-family-base);
  font-size: var(--font-size-md);
  line-height: var(--line-height-160);
  min-width: 0;
}

._TeGew strong {
  font-weight: var(--font-weight-semibold);
}

.v3CG6f {
  font-size: var(--font-size-sm);
  line-height: var(--line-height-160);
  font-weight: var(--font-weight-regular);
}

.MB1LEY {
  background: none;
  border: 0;
  color: inherit;
  cursor: pointer;
  font: inherit;
  padding: 0;
  text-align: left;
  text-decoration: underline;
  text-underline-offset: 2px;
}

.JXcjCl {
  align-self: center;
  flex-shrink: 0;
  padding: 0;
}

.vp0kHU {
  flex-shrink: 0;
  filter: var(--button-icon-filter);
  height: 14px;
  width: 14px;
}

.erNttx {
  position: relative;
}

.u8JNWL {
  margin-top: -15px;
  margin-left: 15px;
}

.MEYgZU {
  opacity: 0.3;
}

.QR9tLw {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: var(--spacing-1);
  width: 100%;
}

.R9EUd8 {
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  justify-content: center;
  gap: 0;
  width: 100%;
}

.XN4ei6 {
  background: var(--text-field-surface, #fafafa);
  border: none;
}

.XN4ei6 .Oyl51I,
.XN4ei6 .HYNh1K,
.r6Vjwt {
  color: var(--disabled-subtle-text, #999999);
}

.XN4ei6 .Oyl51I,
.r6Vjwt {
  font-size: var(--font-size-sm, 14px);
  font-weight: var(--font-weight-regular);
  line-height: var(--line-height-180);
}

.XN4ei6 .F_rUAi {
  font-size: var(--font-size-md, 16px);
  font-weight: var(--font-weight-medium);
  line-height: var(--line-height-100);
}

.r6Vjwt {
  font-family: var(--font-family-base);
}

.u02GSU {
  display: flex;
  flex-direction: column;
  gap: var(--spacing-0-5);
  width: 100%;
}

.trH6ju {
  display: flex;
  gap: var(--spacing-2);
  width: 100%;
}

.trH6ju > * {
  flex: 1;
  height: 32px;
  min-height: 32px;
  max-height: 32px;
}

.vFerYe {
  display: flex;
  flex-direction: column;
  gap: var(--spacing-3);
  width: 100%;
}

.oIt55O {
  font-family: var(--font-family-base);
  font-weight: var(--font-weight-semibold);
  font-size: var(--font-size-lg);
  line-height: var(--line-height-100);
  color: var(--text-neutral-dark);
  margin: 0;
}

.KEopCC {
  display: flex;
  align-items: center;
  gap: var(--spacing-1);
  height: 36px;
  padding: 0 var(--spacing-1-5);
  border: 1px solid var(--stroke-neutral-silver);
  border-radius: var(--radius-s);
  background: var(--surface-neutral-white);
}

.TUY1Lm {
  flex-shrink: 0;
  width: 16px;
  height: 16px;
}

.ZDArcl {
  flex: 1;
  border: none;
  outline: none;
  background: transparent;
  font-family: var(--font-family-base);
  font-size: var(--font-size-md);
  color: var(--text-neutral-dark);
  min-width: 0;
}

.ZDArcl::placeholder {
  color: var(--text-neutral-stronger);
}

.YwmH84 {
  border: none;
  background: none;
  padding: 0;
  cursor: pointer;
  display: flex;
  align-items: center;
  justify-content: center;
}

.qCNfd8 {
  display: flex;
  flex-direction: column;
  gap: var(--spacing-2);
}

.IqJ7yn {
  display: flex;
  align-items: flex-start;
  justify-content: space-between;
  gap: var(--spacing-2);
  padding-bottom: var(--spacing-2);
}

.IqJ7yn:not(:last-child) {
  border-bottom: 1px solid var(--stroke-neutral-subtle);
}

.LeMz8o {
  display: flex;
  flex-direction: column;
  gap: var(--spacing-0-5);
  min-width: 0;
}

.C_A0S0 {
  display: flex;
  align-items: center;
  gap: var(--spacing-0-5);
}

.to2QR0 {
  font-family: var(--font-family-base);
  font-weight: var(--font-weight-semibold);
  font-size: var(--font-size-md);
  line-height: var(--line-height-160);
  color: var(--text-neutral-dark);
}

._6R588 {
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  gap: var(--spacing-0-5);
  min-width: 0;
}

.nc_5Gj {
  font-family: var(--font-family-base);
  font-weight: var(--font-weight-regular);
  font-size: var(--font-size-sm);
  line-height: var(--line-height-160);
  color: var(--text-neutral-stronger);
  word-break: break-word;
}

.Hl_zcu {
  font-family: var(--font-family-base);
  font-weight: var(--font-weight-semibold);
  font-size: var(--font-size-md);
  line-height: var(--line-height-160);
  color: var(--text-neutral-dark);
  white-space: nowrap;
}

.TJCWTD {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  gap: var(--spacing-1);
  padding: var(--spacing-3) 0;
  text-align: center;
}

.KcOVMY {
  font-family: var(--font-family-base);
  font-weight: var(--font-weight-semibold);
  font-size: var(--font-size-md);
  color: var(--text-neutral-dark);
  margin: 0;
}

.Nw0PR6 {
  font-family: var(--font-family-base);
  font-weight: var(--font-weight-regular);
  font-size: var(--font-size-md);
  color: var(--text-neutral-stronger);
  margin: 0;
}

.u4p5fQ {
  display: flex;
  flex-direction: column;
  gap: var(--spacing-1);
  margin-bottom: var(--spacing-2);
}

.gIO_9j {
  border-radius: var(--radius-s);
  margin: 0;
  min-width: 0;
  width: 100%;
}
`, "",{"version":3,"sources":["webpack://./../../packages/beneficios/src/pages/EmissorOrderDetailsPage/EmissorOrderDetailsPage.module.css"],"names":[],"mappings":"AAAA;EACE,aAAa;EACb,YAAY;EACZ,4CAA4C;EAC5C,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,qBAAqB;EACrB,UAAU;EACV,aAAa;EACb,WAAW;AACb;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,qDAAqD;EACrD,sBAAsB;EACtB,cAAc;EACd,qBAAqB;EACrB,YAAY;EACZ,qCAAqC;EACrC,gBAAgB;EAChB,4CAA4C;EAC5C,uDAAuD;AACzD;;AAEA;EACE,gBAAgB;EAChB,uBAAuB;EACvB,SAAS;EACT,+BAA+B;EAC/B,OAAO;EACP,oCAAoC;EACpC,8BAA8B;EAC9B,uCAAuC;EACvC,mCAAmC;EACnC,sBAAsB;EACtB,yBAAyB;EACzB,kBAAkB;EAClB,mBAAmB;AACrB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,+CAA+C;EAC/C,oBAAoB;AACtB;;AAEA;EACE,+BAA+B;EAC/B,oCAAoC;EACpC,8BAA8B;EAC9B,sCAAsC;EACtC,mCAAmC;EACnC,SAAS;AACX;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,qBAAqB;EACrB,mCAAmC;EACnC,WAAW;AACb;;AAEA;EACE,+BAA+B;EAC/B,oCAAoC;EACpC,8BAA8B;EAC9B,wCAAwC;EACxC,mCAAmC;EACnC,SAAS;AACX;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,uBAAuB;EACvB,iBAAiB;EACjB,qBAAqB;EACrB,yBAAyB;AAC3B;;AAEA;EACE,oCAAoC;EACpC,wCAAwC;EACxC,8BAA8B;EAC9B,mCAAmC;EACnC,+BAA+B;EAC/B,SAAS;EACT,kBAAkB;AACpB;;AAEA;EACE,oCAAoC;EACpC,uCAAuC;EACvC,8BAA8B;EAC9B,mCAAmC;EACnC,mCAAmC;EACnC,SAAS;EACT,kBAAkB;AACpB;;AAEA;;EAEE,wCAAwC;EACxC,8CAA8C;EAC9C,8BAA8B;EAC9B,yBAAyB;EACzB,aAAa;EACb,sBAAsB;EACtB,qBAAqB;EACrB,WAAW;EACX,sBAAsB;AACxB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,uBAAuB;AACzB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,uBAAuB;AACzB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,uBAAuB;AACzB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,uBAAuB;EACvB,MAAM;AACR;;AAEA;EACE,aAAa;EACb,qBAAqB;EACrB,8BAA8B;EAC9B,qBAAqB;AACvB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,uBAAuB;EACvB,gBAAgB;AAClB;;AAEA;EACE,oCAAoC;EACpC,uCAAuC;EACvC,8BAA8B;EAC9B,mCAAmC;EACnC,+BAA+B;AACjC;;AAEA;EACE,oCAAoC;EACpC,wCAAwC;EACxC,8BAA8B;EAC9B,mCAAmC;EACnC,+BAA+B;AACjC;;AAEA;EACE,8BAA8B;EAC9B,mCAAmC;AACrC;;AAEA;EACE,YAAY;EACZ,kDAAkD;EAClD,SAAS;EACT,WAAW;AACb;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,cAAc;AAChB;;AAEA;EACE,uBAAuB;EACvB,wBAAwB;EACxB,UAAU;EACV,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,gBAAgB;EAChB,YAAY;EACZ,eAAe;EACf,cAAc;AAChB;;AAEA;EACE,uBAAuB;EACvB,SAAS;EACT,UAAU;EACV,mBAAmB;EACnB,cAAc;AAChB;;AAEA;EACE,wCAAwC;EACxC,8CAA8C;EAC9C,8BAA8B;EAC9B,sBAAsB;EACtB,aAAa;EACb,sBAAsB;EACtB,qBAAqB;EACrB,yBAAyB;EACzB,WAAW;AACb;;AAEA;EACE,uBAAuB;EACvB,aAAa;EACb,qBAAqB;EACrB,WAAW;AACb;;AAEA;EACE,mBAAmB;EACnB,kBAAkB;EAClB,aAAa;EACb,cAAc;EACd,YAAY;EACZ,uBAAuB;EACvB,WAAW;AACb;;AAEA;EACE,+CAA+C;AACjD;;AAEA;EACE,4CAA4C;AAC9C;;AAEA;EACE,kDAAkD;AACpD;;AAEA;EACE,YAAY;EACZ,WAAW;AACb;;AAEA;EACE,+BAA+B;EAC/B,aAAa;EACb,OAAO;EACP,sBAAsB;EACtB,oCAAoC;EACpC,8BAA8B;EAC9B,mCAAmC;EACnC,YAAY;AACd;;AAEA;EACE,wCAAwC;AAC1C;;AAEA;EACE,8BAA8B;EAC9B,mCAAmC;EACnC,uCAAuC;AACzC;;AAEA;EACE,gBAAgB;EAChB,SAAS;EACT,cAAc;EACd,eAAe;EACf,aAAa;EACb,UAAU;EACV,gBAAgB;EAChB,0BAA0B;EAC1B,0BAA0B;AAC5B;;AAEA;EACE,kBAAkB;EAClB,cAAc;EACd,UAAU;AACZ;;AAEA;EACE,cAAc;EACd,iCAAiC;EACjC,YAAY;EACZ,WAAW;AACb;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,iBAAiB;EACjB,iBAAiB;AACnB;;AAEA;EACE,YAAY;AACd;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,qBAAqB;EACrB,WAAW;AACb;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,uBAAuB;EACvB,uBAAuB;EACvB,MAAM;EACN,WAAW;AACb;;AAEA;EACE,8CAA8C;EAC9C,YAAY;AACd;;AAEA;;;EAGE,2CAA2C;AAC7C;;AAEA;;EAEE,oCAAoC;EACpC,uCAAuC;EACvC,mCAAmC;AACrC;;AAEA;EACE,oCAAoC;EACpC,sCAAsC;EACtC,mCAAmC;AACrC;;AAEA;EACE,oCAAoC;AACtC;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,uBAAuB;EACvB,WAAW;AACb;;AAEA;EACE,aAAa;EACb,qBAAqB;EACrB,WAAW;AACb;;AAEA;EACE,OAAO;EACP,YAAY;EACZ,gBAAgB;EAChB,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,qBAAqB;EACrB,WAAW;AACb;;AAEA;EACE,oCAAoC;EACpC,wCAAwC;EACxC,8BAA8B;EAC9B,mCAAmC;EACnC,+BAA+B;EAC/B,SAAS;AACX;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,qBAAqB;EACrB,YAAY;EACZ,6BAA6B;EAC7B,8CAA8C;EAC9C,8BAA8B;EAC9B,wCAAwC;AAC1C;;AAEA;EACE,cAAc;EACd,WAAW;EACX,YAAY;AACd;;AAEA;EACE,OAAO;EACP,YAAY;EACZ,aAAa;EACb,uBAAuB;EACvB,oCAAoC;EACpC,8BAA8B;EAC9B,+BAA+B;EAC/B,YAAY;AACd;;AAEA;EACE,mCAAmC;AACrC;;AAEA;EACE,YAAY;EACZ,gBAAgB;EAChB,UAAU;EACV,eAAe;EACf,aAAa;EACb,mBAAmB;EACnB,uBAAuB;AACzB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,qBAAqB;AACvB;;AAEA;EACE,aAAa;EACb,uBAAuB;EACvB,8BAA8B;EAC9B,qBAAqB;EACrB,gCAAgC;AAClC;;AAEA;EACE,qDAAqD;AACvD;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,uBAAuB;EACvB,YAAY;AACd;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,uBAAuB;AACzB;;AAEA;EACE,oCAAoC;EACpC,wCAAwC;EACxC,8BAA8B;EAC9B,mCAAmC;EACnC,+BAA+B;AACjC;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,uBAAuB;EACvB,uBAAuB;EACvB,YAAY;AACd;;AAEA;EACE,oCAAoC;EACpC,uCAAuC;EACvC,8BAA8B;EAC9B,mCAAmC;EACnC,mCAAmC;EACnC,sBAAsB;AACxB;;AAEA;EACE,oCAAoC;EACpC,wCAAwC;EACxC,8BAA8B;EAC9B,mCAAmC;EACnC,+BAA+B;EAC/B,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,uBAAuB;EACvB,qBAAqB;EACrB,2BAA2B;EAC3B,kBAAkB;AACpB;;AAEA;EACE,oCAAoC;EACpC,wCAAwC;EACxC,8BAA8B;EAC9B,+BAA+B;EAC/B,SAAS;AACX;;AAEA;EACE,oCAAoC;EACpC,uCAAuC;EACvC,8BAA8B;EAC9B,mCAAmC;EACnC,SAAS;AACX;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,qBAAqB;EACrB,+BAA+B;AACjC;;AAEA;EACE,8BAA8B;EAC9B,SAAS;EACT,YAAY;EACZ,WAAW;AACb","sourcesContent":[".drawerShell {\n  display: flex;\n  flex-grow: 1;\n  padding: 0 var(--spacing-3) var(--spacing-3);\n  overflow-y: auto;\n}\n\n.drawerBody {\n  display: flex;\n  flex-direction: column;\n  gap: var(--spacing-3);\n  padding: 0;\n  min-height: 0;\n  width: 100%;\n}\n\n.anchorNavigation {\n  display: flex;\n  align-items: center;\n  border-bottom: 1px solid var(--stroke-neutral-subtle);\n  box-sizing: border-box;\n  flex-shrink: 0;\n  gap: var(--spacing-3);\n  height: 60px;\n  margin: 0 calc(var(--spacing-3) * -1);\n  overflow-x: auto;\n  padding: var(--spacing-3) var(--spacing-3) 0;\n  width: calc(100% + var(--spacing-3) + var(--spacing-3));\n}\n\n.anchorButton {\n  appearance: none;\n  background: transparent;\n  border: 0;\n  color: var(--text-neutral-dark);\n  flex: 1;\n  font-family: var(--font-family-base);\n  font-size: var(--font-size-sm);\n  font-weight: var(--font-weight-regular);\n  line-height: var(--line-height-100);\n  min-width: max-content;\n  padding: var(--spacing-1);\n  text-align: center;\n  white-space: nowrap;\n}\n\n.anchorButtonCompact {\n  flex: 0 0 auto;\n}\n\n.anchorButton:focus-visible {\n  outline: 2px solid var(--stroke-primary-medium);\n  outline-offset: -2px;\n}\n\n.summaryTitle {\n  color: var(--text-neutral-dark);\n  font-family: var(--font-family-base);\n  font-size: var(--font-size-lg);\n  font-weight: var(--font-weight-medium);\n  line-height: var(--line-height-100);\n  margin: 0;\n}\n\n.detailSection {\n  display: flex;\n  flex-direction: column;\n  gap: var(--spacing-2);\n  scroll-margin-top: var(--spacing-2);\n  width: 100%;\n}\n\n.sectionTitle {\n  color: var(--text-neutral-dark);\n  font-family: var(--font-family-base);\n  font-size: var(--font-size-lg);\n  font-weight: var(--font-weight-semibold);\n  line-height: var(--line-height-100);\n  margin: 0;\n}\n\n.feedbackContainer {\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  justify-content: center;\n  min-height: 240px;\n  gap: var(--spacing-2);\n  padding: var(--spacing-3);\n}\n\n.feedbackTitle {\n  font-family: var(--font-family-base);\n  font-weight: var(--font-weight-semibold);\n  font-size: var(--font-size-md);\n  line-height: var(--line-height-180);\n  color: var(--text-neutral-dark);\n  margin: 0;\n  text-align: center;\n}\n\n.feedbackText {\n  font-family: var(--font-family-base);\n  font-weight: var(--font-weight-regular);\n  font-size: var(--font-size-md);\n  line-height: var(--line-height-180);\n  color: var(--text-neutral-stronger);\n  margin: 0;\n  text-align: center;\n}\n\n.infoCard,\n.paymentCard {\n  background: var(--surface-neutral-white);\n  border: 1px solid var(--stroke-neutral-subtle);\n  border-radius: var(--radius-s);\n  padding: var(--spacing-3);\n  display: flex;\n  flex-direction: column;\n  gap: var(--spacing-2);\n  width: 100%;\n  box-sizing: border-box;\n}\n\n.infoGroup {\n  display: flex;\n  flex-direction: column;\n  gap: var(--spacing-0-5);\n}\n\n.infoGroupSpaced {\n  display: flex;\n  flex-direction: column;\n  gap: var(--spacing-0-5);\n}\n\n.summaryRows {\n  display: flex;\n  flex-direction: column;\n  gap: var(--spacing-0-5);\n}\n\n.stackField {\n  display: flex;\n  flex-direction: column;\n  align-items: flex-start;\n  gap: 0;\n}\n\n.productRow {\n  display: flex;\n  align-items: flex-end;\n  justify-content: space-between;\n  gap: var(--spacing-1);\n}\n\n.inlineRow {\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  gap: var(--spacing-0-5);\n  min-height: 25px;\n}\n\n.label {\n  font-family: var(--font-family-base);\n  font-weight: var(--font-weight-regular);\n  font-size: var(--font-size-md);\n  line-height: var(--line-height-180);\n  color: var(--text-neutral-dark);\n}\n\n.value {\n  font-family: var(--font-family-base);\n  font-weight: var(--font-weight-semibold);\n  font-size: var(--font-size-md);\n  line-height: var(--line-height-180);\n  color: var(--text-neutral-dark);\n}\n\n.stackValue {\n  font-size: var(--font-size-lg);\n  line-height: var(--line-height-100);\n}\n\n.separator {\n  border: none;\n  border-top: 1px solid var(--stroke-neutral-subtle);\n  margin: 0;\n  width: 100%;\n}\n\n.valueWithAction {\n  display: flex;\n  align-items: center;\n  gap: var(--spacing-0-5);\n  flex-shrink: 0;\n}\n\n.iconButton {\n  width: var(--spacing-3);\n  height: var(--spacing-3);\n  padding: 0;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  background: none;\n  border: none;\n  cursor: pointer;\n  flex-shrink: 0;\n}\n\n.downloadButton {\n  gap: var(--spacing-0-5);\n  margin: 0;\n  padding: 0;\n  white-space: nowrap;\n  flex-shrink: 0;\n}\n\n.documentsCard {\n  background: var(--surface-neutral-white);\n  border: 1px solid var(--stroke-neutral-subtle);\n  border-radius: var(--radius-s);\n  box-sizing: border-box;\n  display: flex;\n  flex-direction: column;\n  gap: var(--spacing-2);\n  padding: var(--spacing-3);\n  width: 100%;\n}\n\n.documentRow {\n  align-items: flex-start;\n  display: flex;\n  gap: var(--spacing-1);\n  width: 100%;\n}\n\n.documentStatusIcon {\n  align-items: center;\n  border-radius: 50%;\n  display: flex;\n  flex-shrink: 0;\n  height: 22px;\n  justify-content: center;\n  width: 22px;\n}\n\n.documentStatusavailable {\n  background: var(--status-success-soft, #eef8ec);\n}\n\n.documentStatusawaiting {\n  background: var(--status-info-soft, #e6f2fe);\n}\n\n.documentStatusunavailable {\n  background: var(--surface-neutral-subtle, #f2f2f2);\n}\n\n.documentStatusGlyph {\n  height: 12px;\n  width: 12px;\n}\n\n.documentContent {\n  color: var(--text-neutral-dark);\n  display: flex;\n  flex: 1;\n  flex-direction: column;\n  font-family: var(--font-family-base);\n  font-size: var(--font-size-md);\n  line-height: var(--line-height-160);\n  min-width: 0;\n}\n\n.documentContent strong {\n  font-weight: var(--font-weight-semibold);\n}\n\n.documentDescription {\n  font-size: var(--font-size-sm);\n  line-height: var(--line-height-160);\n  font-weight: var(--font-weight-regular);\n}\n\n.documentSupport {\n  background: none;\n  border: 0;\n  color: inherit;\n  cursor: pointer;\n  font: inherit;\n  padding: 0;\n  text-align: left;\n  text-decoration: underline;\n  text-underline-offset: 2px;\n}\n\n.documentAction {\n  align-self: center;\n  flex-shrink: 0;\n  padding: 0;\n}\n\n.documentActionIcon {\n  flex-shrink: 0;\n  filter: var(--button-icon-filter);\n  height: 14px;\n  width: 14px;\n}\n\n.buttonWithCalendar {\n  position: relative;\n}\n\n.calendarDatePicker {\n  margin-top: -15px;\n  margin-left: 15px;\n}\n\n.loadingValue {\n  opacity: 0.3;\n}\n\n.amountRow {\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  gap: var(--spacing-1);\n  width: 100%;\n}\n\n.amountStack {\n  display: flex;\n  flex-direction: column;\n  align-items: flex-start;\n  justify-content: center;\n  gap: 0;\n  width: 100%;\n}\n\n.cancelledPaymentCard {\n  background: var(--text-field-surface, #fafafa);\n  border: none;\n}\n\n.cancelledPaymentCard .label,\n.cancelledPaymentCard .value,\n.cancelledPaymentStatus {\n  color: var(--disabled-subtle-text, #999999);\n}\n\n.cancelledPaymentCard .label,\n.cancelledPaymentStatus {\n  font-size: var(--font-size-sm, 14px);\n  font-weight: var(--font-weight-regular);\n  line-height: var(--line-height-180);\n}\n\n.cancelledPaymentCard .stackValue {\n  font-size: var(--font-size-md, 16px);\n  font-weight: var(--font-weight-medium);\n  line-height: var(--line-height-100);\n}\n\n.cancelledPaymentStatus {\n  font-family: var(--font-family-base);\n}\n\n.paidInfoGroup {\n  display: flex;\n  flex-direction: column;\n  gap: var(--spacing-0-5);\n  width: 100%;\n}\n\n.actionsRow {\n  display: flex;\n  gap: var(--spacing-2);\n  width: 100%;\n}\n\n.actionsRow > * {\n  flex: 1;\n  height: 32px;\n  min-height: 32px;\n  max-height: 32px;\n}\n\n.collaboratorsSection {\n  display: flex;\n  flex-direction: column;\n  gap: var(--spacing-3);\n  width: 100%;\n}\n\n.collaboratorsTitle {\n  font-family: var(--font-family-base);\n  font-weight: var(--font-weight-semibold);\n  font-size: var(--font-size-lg);\n  line-height: var(--line-height-100);\n  color: var(--text-neutral-dark);\n  margin: 0;\n}\n\n.searchField {\n  display: flex;\n  align-items: center;\n  gap: var(--spacing-1);\n  height: 36px;\n  padding: 0 var(--spacing-1-5);\n  border: 1px solid var(--stroke-neutral-silver);\n  border-radius: var(--radius-s);\n  background: var(--surface-neutral-white);\n}\n\n.searchIcon {\n  flex-shrink: 0;\n  width: 16px;\n  height: 16px;\n}\n\n.searchInput {\n  flex: 1;\n  border: none;\n  outline: none;\n  background: transparent;\n  font-family: var(--font-family-base);\n  font-size: var(--font-size-md);\n  color: var(--text-neutral-dark);\n  min-width: 0;\n}\n\n.searchInput::placeholder {\n  color: var(--text-neutral-stronger);\n}\n\n.searchClear {\n  border: none;\n  background: none;\n  padding: 0;\n  cursor: pointer;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n}\n\n.collaboratorsList {\n  display: flex;\n  flex-direction: column;\n  gap: var(--spacing-2);\n}\n\n.collaboratorRow {\n  display: flex;\n  align-items: flex-start;\n  justify-content: space-between;\n  gap: var(--spacing-2);\n  padding-bottom: var(--spacing-2);\n}\n\n.collaboratorRow:not(:last-child) {\n  border-bottom: 1px solid var(--stroke-neutral-subtle);\n}\n\n.collaboratorInfo {\n  display: flex;\n  flex-direction: column;\n  gap: var(--spacing-0-5);\n  min-width: 0;\n}\n\n.collaboratorNameRow {\n  display: flex;\n  align-items: center;\n  gap: var(--spacing-0-5);\n}\n\n.collaboratorName {\n  font-family: var(--font-family-base);\n  font-weight: var(--font-weight-semibold);\n  font-size: var(--font-size-md);\n  line-height: var(--line-height-160);\n  color: var(--text-neutral-dark);\n}\n\n.collaboratorMetaRow {\n  display: flex;\n  flex-direction: column;\n  align-items: flex-start;\n  gap: var(--spacing-0-5);\n  min-width: 0;\n}\n\n.collaboratorMeta {\n  font-family: var(--font-family-base);\n  font-weight: var(--font-weight-regular);\n  font-size: var(--font-size-sm);\n  line-height: var(--line-height-160);\n  color: var(--text-neutral-stronger);\n  word-break: break-word;\n}\n\n.collaboratorAmount {\n  font-family: var(--font-family-base);\n  font-weight: var(--font-weight-semibold);\n  font-size: var(--font-size-md);\n  line-height: var(--line-height-160);\n  color: var(--text-neutral-dark);\n  white-space: nowrap;\n}\n\n.emptySearch {\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  justify-content: center;\n  gap: var(--spacing-1);\n  padding: var(--spacing-3) 0;\n  text-align: center;\n}\n\n.emptyTitle {\n  font-family: var(--font-family-base);\n  font-weight: var(--font-weight-semibold);\n  font-size: var(--font-size-md);\n  color: var(--text-neutral-dark);\n  margin: 0;\n}\n\n.emptyBody {\n  font-family: var(--font-family-base);\n  font-weight: var(--font-weight-regular);\n  font-size: var(--font-size-md);\n  color: var(--text-neutral-stronger);\n  margin: 0;\n}\n\n.alertStack {\n  display: flex;\n  flex-direction: column;\n  gap: var(--spacing-1);\n  margin-bottom: var(--spacing-2);\n}\n\n.inlineAlert {\n  border-radius: var(--radius-s);\n  margin: 0;\n  min-width: 0;\n  width: 100%;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"drawerShell": `bDqMxf`,
	"drawerBody": `IDsnJj`,
	"anchorNavigation": `fbxnfz`,
	"anchorButton": `RMINW0`,
	"anchorButtonCompact": `Df9UK5`,
	"summaryTitle": `KdlWP7`,
	"detailSection": `O32hhc`,
	"sectionTitle": `cCeyT9`,
	"feedbackContainer": `cEeBnF`,
	"feedbackTitle": `wNc7mK`,
	"feedbackText": `BcNUH6`,
	"infoCard": `pSKvBs`,
	"paymentCard": `gwgJEz`,
	"infoGroup": `s5qDEy`,
	"infoGroupSpaced": `F7nt7x`,
	"summaryRows": `lfUn_z`,
	"stackField": `bigyWc`,
	"productRow": `LosSCr`,
	"inlineRow": `DCg1pb`,
	"label": `Oyl51I`,
	"value": `HYNh1K`,
	"stackValue": `F_rUAi`,
	"separator": `bdy9qW`,
	"valueWithAction": `Towdbi`,
	"iconButton": `HERnfr`,
	"downloadButton": `SVkSGa`,
	"documentsCard": `nmU_B4`,
	"documentRow": `CRM1St`,
	"documentStatusIcon": `nkh1UN`,
	"documentStatusavailable": `smNzXt`,
	"documentStatusawaiting": `SYiDJp`,
	"documentStatusunavailable": `h3SIfX`,
	"documentStatusGlyph": `YIsqnM`,
	"documentContent": `_TeGew`,
	"documentDescription": `v3CG6f`,
	"documentSupport": `MB1LEY`,
	"documentAction": `JXcjCl`,
	"documentActionIcon": `vp0kHU`,
	"buttonWithCalendar": `erNttx`,
	"calendarDatePicker": `u8JNWL`,
	"loadingValue": `MEYgZU`,
	"amountRow": `QR9tLw`,
	"amountStack": `R9EUd8`,
	"cancelledPaymentCard": `XN4ei6`,
	"cancelledPaymentStatus": `r6Vjwt`,
	"paidInfoGroup": `u02GSU`,
	"actionsRow": `trH6ju`,
	"collaboratorsSection": `vFerYe`,
	"collaboratorsTitle": `oIt55O`,
	"searchField": `KEopCC`,
	"searchIcon": `TUY1Lm`,
	"searchInput": `ZDArcl`,
	"searchClear": `YwmH84`,
	"collaboratorsList": `qCNfd8`,
	"collaboratorRow": `IqJ7yn`,
	"collaboratorInfo": `LeMz8o`,
	"collaboratorNameRow": `C_A0S0`,
	"collaboratorName": `to2QR0`,
	"collaboratorMetaRow": `_6R588`,
	"collaboratorMeta": `nc_5Gj`,
	"collaboratorAmount": `Hl_zcu`,
	"emptySearch": `TJCWTD`,
	"emptyTitle": `KcOVMY`,
	"emptyBody": `Nw0PR6`,
	"alertStack": `u4p5fQ`,
	"inlineAlert": `gIO_9j`
};
module.exports = ___CSS_LOADER_EXPORT___;
